import { useEffect, useMemo, useRef, useState } from "react";
import { useVerification } from "../../../../context/Verification.context";
import { useMutation } from "@apollo/client";
import RenderArtifactContent from "../../verification/document/RenderArtifact.component";
import {
  FETCH_INSURANCE_TRIGGER,
  TRANSACTION_HISTORY,
} from "../../../../graphql/mutation/mutation";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import VerificationLayout from "../../../layout/VerificationLayout.component";
import { ArtifactStyle } from "../../verification/document/artifactResponse/VerficationArtifactsStyles";
import {
  withWalkthroughSlides,
  navigateAfterContinueDeliveryArtifacts,
} from "../../../../utils/videoPlayer";
import { useNavigate } from "react-router-dom";

const ArtifactsPopup = () => {
  const verification = useVerification();
  const navigate = useNavigate();

  const [close, setClose] = useState(false);
  const [saveResponse, setSaveResponse] = useState({});

  const [fetchTransactions] = useMutation(TRANSACTION_HISTORY);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const filterData = {
    customerName: "",
    dealershipName: "",
    date: moment(
      new Date().toLocaleString("en-US", {
        timeZone: userTimezone,
      }),
    ).format("YYYY-MM-DD"),
    timestamp: new Date().getTimezoneOffset(),
  };
  const [fetchTrigger] = useMutation(FETCH_INSURANCE_TRIGGER, {
    onCompleted: (data) => {
      if (data) {
        console.log("DataTrigger", data);
        fetchTransactions({
          variables: {
            transactionInput: {
              date: filterData.date,
              search_customer: "",
              search_dealership: "",
              timestamp: filterData.timestamp,
              pageCount: verification?.fetchData.pageCount,
              rowsPerPage: 5,
              timezone: userTimezone,
            },
          },
        });
      }
    },
  });

  useEffect(() => {
    if (close) {
      // Continue Delivery: quote already done → thank you (do not re-open quote)
      if (verification?.isContinueDelivery) {
        verification.setIsArtifactOpen?.(true);
        navigateAfterContinueDeliveryArtifacts(navigate, verification);
        return;
      }
      verification.setIsContinueDelivery(false);
      window.close();
      let win = window.open("", "_self");
      win.close();
    }
  }, [close, navigate]);

  const baseArtifacts = useMemo(
    () =>
      Array.isArray(verification?.artifacts)
        ? verification?.artifacts
        : verification?.artifacts?.items || [],
    [verification?.artifacts],
  );

  // KW leads artifacts (Insurance WT already before carriers)
  const includeWalkthroughRef = useRef(null);
  if (includeWalkthroughRef.current === null) {
    includeWalkthroughRef.current = {
      insurance: false,
      knowledgeHub: true,
      forceKnowledgeHub: true,
    };
  }

  const artifactsWithWalkthrough = useMemo(
    () =>
      withWalkthroughSlides(baseArtifacts, verification, {
        includeInsurance: false,
        includeKnowledgeHub: includeWalkthroughRef.current.knowledgeHub,
        forceKnowledgeHub: includeWalkthroughRef.current.forceKnowledgeHub,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [baseArtifacts, verification?.walkthroughVideoUrl],
  );

  return (
    <>
      {baseArtifacts.length > 0 ? (
        <RenderArtifactContent
          artifactsArray={artifactsWithWalkthrough}
          isThankyou={true}
          fetchTrigger={fetchTrigger}
          setSaveResponse={setSaveResponse}
          setClose={setClose}
        />
      ) : (
        <>
          <VerificationLayout>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box sx={{ ...ArtifactStyle?.logo, paddingBottom: 10 }}>
                  <img
                    src={verification?.dealershipLogo}
                    width={150}
                    height={60}
                    alt="Dealership Logo"
                  />
                </Box>

                <Typography variant="h6" align="center">
                  There are no artifacts available for this Dealership.
                </Typography>
              </Box>
            </Box>
          </VerificationLayout>
        </>
      )}
    </>
  );
};

export default ArtifactsPopup;
